<template>
    <div class="container">
        <div class="box">
            <h3 class="title reveal-bottom">{{ $t("vn.t1") }}</h3>
            <div class="box-bottom">
                <div class="box-left reveal-bottom">
                    <img
                        style="width:352px;"
                        :src="
                            lang === 'en_US'
                                ? require('@/assets/img_svg/retail_img_2_en.png')
                                : require('@/assets/img_svg/retail_img_2_cn.png')
                        "
                        alt="svg"
                    />
                </div>
                <div class="box-right">
                    <p class="box-text reveal-bottom">
                        {{ $t("vn.c1") }}
                    </p>
                    <div class="box-device">
                        <div class="box-item reveal-bottom">
                            <div class="device-img-wrap">
                                <img class="device-img" :src="imgUrl" alt="" />
                            </div>
                            <h4 class="device-title">R100-X6</h4>
                            <div class="device-mes">
                                <p>
                                    {{ $t("dv.ryc") }}<br />{{ $t("dv.ryc1") }}
                                </p>
                                <p>8000 {{ $t("dv.rxu") }}</p>
                                <p>150Mbps</p>
                            </div>
                        </div>
                        <div class="box-item reveal-bottom">
                            <div class="device-img-wrap">
                                <img class="device-img" :src="imgUrl1" alt="" />
                            </div>
                            <h4 class="device-title">D100-AWL5</h4>
                            <div class="device-mes">
                                <p>
                                    {{ $t("dv.dy") }}<br />{{ $t("dv.ryc1") }}
                                </p>
                                <p>100 {{ $t("dv.rxu") }}</p>
                                <p>40Mbps</p>
                            </div>
                        </div>
                        <div class="box-item reveal-bottom">
                            <div class="device-img-wrap">
                                <img class="device-img" :src="imgUrl2" alt="" />
                            </div>
                            <h4 class="device-title">D200-X4</h4>
                            <div class="device-mes">
                                <p>
                                    {{ $t("dv.dy") }}<br />{{ $t("dv.ryc1") }}
                                </p>
                                <p>100 {{ $t("dv.rxu") }}</p>
                                <p>150-200Mbps</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/devices/R.png"),
            imgUrl1: require("@/assets/images/devices/D100-AWL5.png"),
            imgUrl2: require("@/assets/images/devices/D200-X4.png"),
            lang: localStorage.getItem("lang"),
        };
    },
    mounted() {
        this.$bus.$on("lang", (lang) => (this.lang = lang));
    },
};
</script>
<style scoped>
.container {
    background: #f2f2f2;
    overflow: hidden;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 150px;
}
.box-bottom {
    height: 568px;
    display: flex;
    margin-top: 100px;
    margin-bottom: 196px;
}
.box-left {
    flex-basis: 350px;
    height: 568px;
}
.img {
    width: 100%;
    height: 100%;
}
.box-right {
    flex: 1;
    margin-left: 75px;
}
.box-text {
    height: 198px;
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 44px;
}
.box-device {
    display: flex;
    justify-content: space-between;
}
.box-item {
    width: 245px;
    height: 370px;
    background-color: #fff;
    border: 2px solid #000;
    padding: 22px;
    box-sizing: border-box;
}
.device-img-wrap {
    height: 180px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    position: relative;
}
.device-title {
    font-size: 16px;
    color: #000000;
    margin-top: 25px;
    margin-bottom: 23px;
    line-height: 16px;
}
.device-mes {
    font-size: 14px;
    color: #000000;
    line-height: 21px;
}
.device-img {
    width: 167px;
    height: 102px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Retail/Content1.vue